import { render } from "./SuccessBanner.vue?vue&type=template&id=dd8978ca"
import script from "./SuccessBanner.vue?vue&type=script&lang=js"
export * from "./SuccessBanner.vue?vue&type=script&lang=js"

import "./SuccessBanner.vue?vue&type=style&index=0&id=dd8978ca&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__